export default __webpack_public_path__ + "static/media/latitude-bold-logo.93a25bf1.svg";